var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Link as RouterLink, } from 'react-router-dom';
import styled from 'styled-components';
import useHasReactRouterContext from '../../hooks/useHasReactRouterContext';
export function isExternalLink(to) {
    return (typeof to === 'string' &&
        (to.startsWith('http://') || to.startsWith('https://')));
}
export const AnchorElement = styled.a `
  color: inherit;
  text-decoration: none;
`;
/**
 * HINT: This is a helper component to render a link that can handle both internal and external links.
 *
 * Renders a link component that can handle both internal and external links.
 * If React Router is available, it uses the RouterLink component, otherwise it falls back to an anchor element.
 *
 * @param {LinkProps} props - The props for the Link component.
 * @returns {JSX.Element} The rendered Link component.
 */
export function Link(_a) {
    var { className = undefined, title = undefined, to, children } = _a, rest = __rest(_a, ["className", "title", "to", "children"]);
    const hasReactRouter = useHasReactRouterContext();
    if (isExternalLink(to) || (!hasReactRouter && typeof to === 'string')) {
        return (React.createElement(AnchorElement, Object.assign({}, rest, { className: className, href: to }), children));
    }
    return (React.createElement(RouterLink, Object.assign({ className: className, to: to }, rest), children));
}
